module.exports = __webpack_public_path__ + "img/logo-curnon.51711733.svg";